import { LanguageOption } from './LanguageOption';

export const languageRecord: Record<LanguageOption, string> = {
	nl: 'Nederlands',
	en: 'English',
	fr: 'Français',
};
